import { useEffect, useState, useCallback } from "react";
import { api, ACCOUNT_COLORS, ACCOUNT_LABEL } from "@/lib/api";

function relTime(iso) {
  if (!iso) return "";
  const t = new Date(iso).getTime();
  const diff = Math.max(0, Date.now() - t);
  const s = Math.floor(diff / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}

export default function LeagueFeed({ leagueId, refreshKey = 0 }) {
  const [posts, setPosts] = useState([]);

  const load = useCallback(() => {
    if (!leagueId) return;
    api.getFeed(leagueId).then(setPosts).catch(() => {});
  }, [leagueId]);

  useEffect(() => {
    load();
    const t = setInterval(load, 12000);
    return () => clearInterval(t);
  }, [load, refreshKey]);

  return (
    <div className="border border-[var(--stakes-border)] bg-[var(--stakes-surface)]" data-testid="league-feed">
      <div className="p-5 border-b border-[var(--stakes-border)] flex items-center justify-between">
        <div>
          <div className="label-mono">LEAGUE FEED</div>
          <h3 className="font-anton text-3xl uppercase leading-none mt-1">Proof Wall</h3>
        </div>
        <div className="label-mono">{posts.length} POST{posts.length === 1 ? "" : "S"}</div>
      </div>

      {posts.length === 0 ? (
        <div className="p-10 text-center">
          <div className="label-mono mb-2">NO PROOF YET</div>
          <div className="font-barlow text-lg text-[var(--stakes-muted)] uppercase">
            Snap a photo when you check in YES to start the wall.
          </div>
        </div>
      ) : (
        <div className="divide-y divide-[var(--stakes-border)] max-h-[640px] overflow-y-auto">
          {posts.map((p) => {
            const color = ACCOUNT_COLORS[p.user_role] || "#fff";
            return (
              <article
                key={p.id}
                className="p-5 flex gap-4"
                data-testid={`feed-post-${p.id}`}
              >
                <div className="flex-shrink-0">
                  <div
                    className="w-12 h-12 flex items-center justify-center font-anton text-2xl"
                    style={{ background: color, color: "#000" }}
                  >
                    {p.user_name.slice(0, 1).toUpperCase()}
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 flex-wrap">
                    <span className="font-anton text-2xl uppercase leading-none">{p.user_name}</span>
                    <span className="label-mono" style={{ color }}>
                      {ACCOUNT_LABEL[p.user_role]}
                    </span>
                    <span className="label-mono text-[var(--stakes-muted)]">{relTime(p.created_at)}</span>
                  </div>
                  <div className="font-barlow text-lg uppercase tracking-wide mt-2 leading-snug">
                    <span className="text-[var(--stakes-muted)]">RULE #{p.rule_index + 1} —</span>{" "}
                    {p.rule_text || "—"}
                  </div>
                  <div className="mt-3 border border-[var(--stakes-border)] bg-black overflow-hidden">
                    <img
                      src={api.fileUrl(p.photo_path)}
                      alt={`${p.user_name} — ${p.rule_text}`}
                      className="w-full max-h-96 object-cover block"
                      loading="lazy"
                    />
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
}
